import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import FaceDetection from "./assets/images/sample.jpg";
import FaceDetectionResult from "./assets/images/finaloutput.png";
import vehicledetction from "./assets/images/vehicledetction2.jpg";
import vehicledetctionResult from "./assets/images/vehicledetectionoutput2.jpg";
import safteydetction from "./assets/images/safetydetectionimage2.jpg";
import safteydetctionResult from "./assets/images/safetydetectionimage3.jpg";
import objectdetction from "./assets/images/object1.png";
import objectdetctionResult from "./assets/images/object output.png";



function InvoiceInfo() {
  return (
    <>
      {/* Invoice page start */}
      <div
        className="text-center text-white bg_header mb-5"
        style={{
          background:
            "url('https://img.freepik.com/free-photo/cheese-spaghetti-pasta-white-blank-paper-black-backdrop_23-2148087356.jpg?t=st=1741086231~exp=1741089831~hmac=7c7c2a179456a6bd8a0572cb8420bd3c9aff4639dbd9fef4eca5c42977ba5c5c&w=1380') center/cover",
          padding: "180px 0",
        }}
      >
        <h1 className="fw-bold mb-4">
          <span className="primary_text">Invoice AI</span> - The Smartest Way to
          Process Invoices!
        </h1>
        <p className="mb-5">
          Automate your financial workflows with
          <span className="primary_text"> AI-powered</span> invoice processing.
        </p>
        <Link to="/register" className="btn btn-light btn-lg fw-bold">
          Sign Up Now
        </Link>
      </div>

      <div class="container mt-5">
        <div class="row text-center invoice_box">
          <div class="col-md-4 mb-4">
            <div class="feature-box">
              <h4>📂 Upload Multiple Invoices</h4>
              <p>
                Supports PDF, JPG, PNG, and JPEG formats (up to 200MB per file).
              </p>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="feature-box">
              <h4>🧠 AI-Powered Data Extraction</h4>
              <p>
                Automatically captures Invoice Number, Date, Vendor Details,
                Customer Information, Subtotals, Taxes, and Total Amount.
              </p>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="feature-box">
              <h4>⏳ Save Time & Eliminate Manual Entry</h4>
              <p>No more manual data input—let AI do the work in seconds!</p>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="feature-box">
              <h4>🔍 High Accuracy with OCR Technology</h4>
              <p>Extracts and organizes data with precision.</p>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="feature-box">
              <h4>📊 Structured & Searchable Data</h4>
              <p>
                Easily filter, search, and analyze extracted invoice details.
              </p>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="feature-box">
              <h4>🌍 Multi-Language Support</h4>
              <p>Works with invoices in different languages.</p>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="feature-box">
              <h4>🔒 Secured & Encrypted</h4>
              <p>Your invoice data is processed with top-tier security.</p>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="feature-box">
              <h4>🔗 Seamless Integration</h4>
              <p>
                Connects with accounting software, databases, and ERP systems.
              </p>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="feature-box">
              <h4>🖥️ User-Friendly Interface</h4>
              <p>No technical expertise required—simply upload and extract!</p>
            </div>
          </div>
        </div>
      </div>

      <div class="container mb-5">
        <div class="cta">
          <h3>How It Works?</h3>
          <ol className="mb-5">
            <li>
              <strong>Register & Log In</strong> – Sign up to access the demo
              and explore Invoice AI.
            </li>
            <li>
              <strong>Upload Your Invoice(s)</strong> – Drag and drop your files
              or browse to select them.
            </li>
            <li>
              <strong>Click "Extract Invoice Data"</strong> – AI processes the
              file and extracts all key details instantly.
            </li>
            <li>
              <strong>View, Download & Integrate</strong> – Get structured,
              accurate invoice data in an easy-to-use format.
            </li>
          </ol>
          <h3>Want to Try Invoice AI?</h3>
          <p>
            <strong>Register now</strong> to access the demo and see how Invoice
            AI can transform your invoice processing!
          </p>
          <h5 className="mb-4">
            <strong>
              Boost productivity, reduce workload, and streamline your financial
              operations with Invoice AI today!
            </strong>
          </h5>
          <p>
            <strong>Sign up now </strong> to experience the future of invoice
            processing!
          </p>
          <Link to="/register" class="btn btn-light btn-lg">
            Get Started
          </Link>
        </div>
      </div>
      {/* Invoice page End */}

      {/* Video Analytic page start */}
      {/* <div
        className="text-center text-white bg_header mb-5"
        style={{
          background:
            "url('https://img.freepik.com/free-photo/ai-technology-brain-background-digital-transformation-concept_53876-125206.jpg?t=st=1741862275~exp=1741865875~hmac=c376bbe7863cd3dba0f9092a949abd3207385e1ffc9760c47b9baf692a7489f0&w=1060') center/cover",
          padding: "180px 0",
        }}
      >
        <h1 className="fw-bold mb-4">
          <span className="primary_text">AI Video Analytics</span> - Smarter Surveillance, Safer Environments!
        </h1>
        <p className="mb-5">
          Transform your security and operations with
          <span className="primary_text"> AI-powered</span> video analytics!
        </p>
      </div>
      <div class="container">
        <div class="row differentiator">
          <div class="col-md-12">
            <div className="card mb-3">
              <div className="card-body">
                <h3>Face Recognition – Identify & Authenticate in Real Time</h3>
                <p className="mb-4">Ensure secure access control by recognizing authorized personnel and flagging unauthorized individuals instantly.</p>
                <div className="row image_differentiator">
                  <div className="col-lg-6"><img src={FaceDetection} alt="Logo" className="img-fluid" /></div>
                  <div className="col-lg-6"><img src={FaceDetectionResult} alt="Logo" className="img-fluid" /></div>
                </div>
                <ul>
                  <li className="mb-2"><b className="d-block">Use Case 1: Corporate Security</b> A company installs AI-driven cameras at entry points. Employees can enter seamlessly with face recognition, while visitors and unauthorized individuals are flagged for manual verification.</li>
                  <li><b className="d-block">Use Case 2: Retail Stores</b> A retail store uses face recognition to identify VIP customers and offer them personalized services while simultaneously detecting known shoplifters.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div className="card mb-3">
              <div className="card-body">
                <h3>Object Detection – Identify Suspicious Objects & Enhance Security</h3>
                <p className="mb-4">Detect unattended items, restricted objects, or misplaced assets within seconds to prevent security breaches.</p>
                <div className="row image_differentiator">
                  <div className="col-lg-6"><img src={objectdetction} alt="Logo" className="img-fluid" /></div>
                  <div className="col-lg-6"><img src={objectdetctionResult} alt="Logo" className="img-fluid" /></div>
                </div>
                <ul>
                  <li className="mb-2"><b className="d-block">Use Case 1: Airport & Public Transport</b> A security system at an airport detects an unattended bag in a busy terminal and alerts authorities instantly, reducing potential security risks.</li>
                  <li><b className="d-block">Use Case 2: Factory Floor Management</b> Manufacturing plants track tools, equipment, and hazardous materials to ensure workplace safety and compliance.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div className="card mb-3">
              <div className="card-body">
                <h3>Vehicle Number Plate Recognition – Automate Access & Security Tracking</h3>
                <p className="mb-4">Capture, store, and analyze vehicle number plates for better security and operational efficiency.</p>
                <div className="row image_differentiator">
                  <div className="col-lg-6"><img src={vehicledetction} alt="Logo" className="img-fluid" style={{ objectPosition: "bottom" }} /></div>
                  <div className="col-lg-6"><img src={vehicledetctionResult} alt="Logo" className="img-fluid" /></div>
                </div>
                <ul>
                  <li className="mb-2"><b className="d-block">Use Case 1: Parking Management</b> A smart parking lot uses AI to recognize vehicle number plates, allowing seamless entry for registered vehicles and automatically billing visitors.</li>
                  <li><b className="d-block">Use Case 2: Law Enforcement & Toll Collection</b> Police track wanted vehicles in real-time, while toll booths automate fee collection by scanning license plates.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div className="card mb-3">
              <div className="card-body">
                <h3>Safety Gear Detection – Ensure Compliance & Workplace Safety</h3>
                <p className="mb-4">Automatically detect whether employees are wearing required safety gear like helmets, gloves, masks, and reflective vests.</p>
                <div className="row image_differentiator">
                  <div className="col-lg-6"><img src={safteydetction} alt="Logo" className="img-fluid" /></div>
                  <div className="col-lg-6"><img src={safteydetctionResult} alt="Logo" className="img-fluid" /></div>
                </div>
                <ul>
                  <li className="mb-2"><b className="d-block">Use Case 1: Construction Site Monitoring</b> AI-powered cameras continuously monitor workers to ensure they wear helmets and vests, reducing workplace accidents.</li>
                  <li><b className="d-block">Use Case 2: Healthcare & Laboratories</b> A hospital enforces hygiene rules by ensuring staff members wear protective masks and gloves in critical areas.</li>
                </ul>
              </div>
            </div>
          </div>
        
        </div>
       
        <div class="row">
          <div class="col-md-12 ">
            <div className="card mb-3">
              <div className="card-body">
                <h3>Additional Features & Benefits</h3>
                <div class="row benefit_wrap mt-3">
                  <div class="col-lg-4"><div class="benefit-item mb-3">
                  <span class="benefit-icon">✅</span> Intrusion Detection – Detect unauthorized access.
                  </div></div>
                  <div class="col-lg-4"><div class="benefit-item mb-3"><span class="benefit-icon">🔥</span> Fire & Smoke Detection – Identify hazards early. </div></div>
                  <div class="col-lg-4"><div class="benefit-item mb-3"><span class="benefit-icon">👥</span> Crowd Monitoring – Prevent overcrowding. </div></div>
                  <div class="col-lg-4"><div class="benefit-item mb-3"><span class="benefit-icon">📊</span> Automated Reports – Instant alerts & insights. </div></div>
                  <div class="col-lg-4"><div class="benefit-item mb-3"><span class="benefit-icon">🔄</span> Seamless Integration – Works with existing systems. </div></div>
                  <div class="col-lg-4"><div class="benefit-item mb-3"><span class="benefit-icon">⚡</span> More Capabilities – Adaptable AI solutions. </div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mb-5">
        <div class="cta">
          <h3>How It Works?</h3>
          <ol className="mb-5">
            <li>
              <strong>Set Up & Integrate</strong> – Connect AI with your CCTV cameras.
            </li>
            <li>
              <strong>AI Begins Monitoring</strong> – Continuous real-time analysis.
            </li>
            <li>
              <strong>Instant Alerts & Insights</strong> – Get notified of security breaches.
            </li>
            <li>
              <strong>Take Action</strong> – Review flagged events and improve security.
            </li>
          </ol>
          <h3>Want to See AI Video Analytics in Action?</h3>
          <p>
            <strong>Schedule a demo now </strong> and experience the future of surveillance and security!
          </p>
          <h5 className="mb-4">
            <strong>
              Enhance security, reduce risks, and improve efficiency with AI-powered video analytics today!
            </strong>
          </h5>

          <Link to="/register" class="btn btn-light btn-lg">
            Contact us now to get started!
          </Link>
        </div>
      </div> */}
      {/* Video Analytic page End */}

      {/* Form 27-5-2025 start */}
      <div className="container">
        <div className="info-highlight-box">
          <div className="intro-text">
            <p>
              <strong>To provide you with an accurate and transparent cost estimate for using <strong>Aivio</strong>, we need a few key details about your expected usage. This helps us:</strong>
            </p>
          </div>

          <div className="info-points">
            <div className="info-item">
              <span className="icon">⚙️</span>
              <p>Optimize the solution based on your actual needs</p>
            </div>
            <div className="info-item">
              <span className="icon">📊</span>
              <p>Estimate infrastructure and AI processing resources</p>
            </div>
            <div className="info-item">
              <span className="icon">💰</span>
              <p>Suggest a suitable pricing model based on volume and growth</p>
            </div>
          </div>

          <div className="note">
            <p className="mb-0"><em>No need to be exact — approximate values are okay!</em></p>
          </div>
        </div>
        <div className="main-card">
          <h1 className="form-title">Usage Estimation Form</h1>
          <form className="user-form">
            <div className="form-section">
              <div className="email-box mb-5">
                <label>Your Email Address:</label>
                <input type="email" name="user_email" placeholder="example@yourdomain.com" required />
                <p className="note small">We’ll use this to send you the estimated cost based on your inputs.</p>
              </div>

              <h2>User Activity</h2>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label>Unique users per month:</label>
                  <input type="number" placeholder="e.g., 150" name="unique_users" required />
                </div>
    
              </div>
            </div>

            <div className="form-section">
              <h2>Document and Data Volume</h2>
              <div className="row">
                <div className="col-lg-4 col-md-6 mb-3">
                  <label>Total documents to be processed:</label>
                  <input type="number" placeholder="e.g., 10,000" name="total_documents" />
                </div>
                <div className="col-lg-4 col-md-6 mb-3">
                  <label>Average size of each document (MB):</label>
                  <input type="number" placeholder="e.g., 2.5" step="0.1" name="doc_size" />
                </div>
                <div className="col-lg-4 col-md-6 mb-3">
                  <label>Average number of words per document:</label>
                  <input type="number" placeholder="e.g., 1,200" name="word_count" />
                </div>
                <div className="col-lg-6 col-md-6 mb-3">
                  <label>Total data volume to be processed (GB):</label>
                  <input type="number" step="0.1" placeholder="e.g., 25.4" name="total_data" />
                </div>
                <div className="col-lg-6 col-md-12 mb-3">
                  <label>Expected annual data volume growth (%):</label>
                  <input type="number" name="growth_rate" placeholder="e.g., 15" />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h2>AI Interaction Volume</h2>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label>AI-based requests per month:</label>
                  <input type="number" name="ai_requests" placeholder="e.g., 5000" />
                </div>
                <div className="col-md-4 mb-3">
                  <label>Average words per prompt:</label>
                  <input type="number" name="prompt_words" placeholder="e.g., 100" />
                </div>
                <div className="col-md-4 mb-3">
                  <label>Average words per response:</label>
                  <input type="number" name="response_words" placeholder="e.g., 150" />
                </div>
              </div>
            </div>

            <div className="submit-box">
              <button type="submit">Submit</button>
            </div>
          </form>
        </div>
      </div >
      {/* Form 27-5-2025 End */}
    </>
  );
}

export default InvoiceInfo;
